<script setup lang="ts">
import type { Color } from '@global-types/colors';
import Typography from './Typography.vue';

type IconType =
  'calendar-question' |
  'calendar-date' |
  'calendar-exclamation' |
  'calendar-checked' |
  'circle-red-cross' |
  'circle-green-check';

interface Props {
  textColor?: Color,
  backgroundColor?: Color,
  icon?: IconType;
}

withDefaults(defineProps<Props>(), {
  textColor: 'black',
  backgroundColor: undefined,
  icon: undefined,
});

</script>

<template>
  <div
    class="tag"
    :class="[
      backgroundColor ? `tag--bg-${backgroundColor}` : ''
    ]"
  >
    <span
      v-if="icon"
      class="tag__icon"
      :class="[
        icon ? `tag__icon-${icon}` : '',
      ]"
    />

    <Typography
      variant="body-small-bold"
      :color="textColor"
    >
      <slot />
    </Typography>
  </div>
</template>
